import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MobileMenu from "../components/MobileMenu";
import LoginModal from "../components/LoginModal";
import {
  FaUser,
  FaUsers,
  FaHospital,
  FaHeartbeat,
  FaShieldAlt,
  FaSearch,
  FaBriefcaseMedical,
  FaArrowRight,
  FaCheckCircle,
} from "react-icons/fa";
import hireCuraIcon from "../assets/hirecura-icon.png";

import Footer from "../components/Footer";
import healthcareHero from "../assets/about-us-hero.png";

function AboutUs() {
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);
const [loginRole, setLoginRole] = useState("candidate");

const openLoginModal = (role) => {
  setLoginRole(role);
  setShowLoginModal(true);
};
  const [loggedUser, setLoggedUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("user"));
    } catch {
      return null;
    }
  });

  return (
    <div className="min-h-screen bg-white">

      {/* ================= HEADER ================= */}
      <header className="sticky top-0 z-50 bg-white border-b border-gray-100">

        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">

          <div className="flex min-w-0 items-center justify-between gap-3">

            {/* LOGO */}
<div
  className="cursor-pointer flex min-w-0 items-center gap-2 sm:gap-3 flex-shrink-0"
  onClick={() =>
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }
>
  {/* HireCura Icon */}
  <img
    src={hireCuraIcon}
    alt="HireCura Icon"
    className="h-9 w-9 sm:h-11 sm:w-11 md:h-12 md:w-12 object-contain"
  />

  {/* Brand Name and Tagline */}
  <div className="flex flex-col">
    <h1 className="text-xl sm:text-2xl md:text-3xl font-bold tracking-tight leading-none">
      <span className="text-slate-900">Hire</span>
      <span className="text-teal-600">Cura</span>
    </h1>

    <p className="text-[8px] sm:text-[10px] md:text-xs text-slate-500 font-medium tracking-wide mt-1">
      Where Careers Meet Care.
    </p>
  </div>
</div>

            {/* NAVIGATION */}
            <nav className="hidden lg:flex items-center gap-8">

              <button
                onClick={() => navigate("/")}
                className="text-gray-700 hover:text-teal-600 transition font-medium"
              >
                Home
              </button>

              <button
                onClick={() => navigate("/find-jobs")}
                className="text-gray-700 hover:text-teal-600 transition font-medium"
              >
                Find Jobs
              </button>

              {loggedUser?.role !== "candidate" && (
  <button
    onClick={() => navigate("/for-employers")}
    className="text-gray-700 hover:text-teal-600 transition font-medium"
  >
    For Employers
  </button>
)}

              <button
                onClick={() => navigate("/how-it-works")}
                className="text-gray-700 hover:text-teal-600 transition font-medium"
              >
                How It Works
              </button>

              {/* ACTIVE */}
              <button
                className="relative text-teal-600 font-semibold"
              >
                About Us

                <span className="absolute -bottom-5 left-0 right-0 h-[3px] bg-teal-600 rounded-full" />
              </button>

              <button
                onClick={() => navigate("/contact-us")}
                className="text-gray-700 hover:text-teal-600 transition font-medium"
              >
                Contact Us
              </button>

            </nav>

            {/* RIGHT SIDE */}
           
<div className="hidden md:flex items-center gap-4">
  {loggedUser ? (
    <>
      <FaUser className="text-[#10243e] text-lg" />
      
            <span className="hidden xl:block text-sm font-semibold text-gray-700">
        Welcome, {loggedUser.name || "User"}
      </span>

      <button
        onClick={() =>
          navigate(
            loggedUser.role === "institution"
              ? "/institution"
              : "/candidate-dashboard"
          )
        }
        className="border border-teal-600 text-teal-700 px-6 py-2 rounded-full font-semibold hover:bg-teal-50 transition"
      >
        Dashboard
      </button>

      <button
        onClick={() => {
          localStorage.removeItem("user");
          localStorage.removeItem("token");
          setLoggedUser(null);
          navigate("/");
        }}
        className="border border-red-500 text-red-600 px-5 py-2 rounded-full hover:bg-red-50 transition"
      >
        Logout
      </button>
    </>
  ) : (
    <>
    <FaUser className="text-[#10243e] text-lg" />

      <button
        onClick={() => openLoginModal("candidate")}
        className="border border-teal-600 text-teal-700 px-6 py-2 rounded-full font-semibold hover:bg-teal-50 transition"
      >
        Login
      </button>

      <button
        onClick={() => openLoginModal("institution")}
        className="bg-teal-600 text-white px-6 py-2 rounded-full font-semibold hover:bg-teal-700 transition"
      >
        Post a Job
      </button>
    </>
  )}
</div>


            <MobileMenu
              onLogin={() => openLoginModal("candidate")}
              loggedUser={loggedUser}
              onLogout={() => {
                localStorage.removeItem("user");
                localStorage.removeItem("token");
                setLoggedUser(null);
                navigate("/");
              }}
            />
          </div>

        </div>
      </header>


      {/* ================= HERO ================= */}
      <section className="relative overflow-hidden bg-gradient-to-br from-white via-[#f3fbfa] to-[#dff5f1]">

        <div className="max-w-7xl mx-auto px-4 sm:px-6">

          <div className="grid lg:grid-cols-2 gap-5 sm:gap-10 items-center min-h-0 lg:min-h-[430px]">

            {/* LEFT */}
            <div className="relative z-10 py-8 sm:py-14">

              <p className="text-xs sm:text-sm md:text-base tracking-[0.16em] sm:tracking-[0.18em] text-[#10243e] font-medium mb-3 sm:mb-4">
                ABOUT HIRECURA
              </p>

              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight sm:leading-[1.08] text-[#10243e]">

                Connecting
                <br />

                <span className="text-teal-600">
                  Healthcare Talent
                </span>

                <br />

                With Better Opportunities

              </h1>

              <p className="mt-4 sm:mt-6 text-base sm:text-lg text-gray-600 max-w-xl leading-6 sm:leading-7">
                HireCura is a healthcare-focused hiring platform designed
                to connect skilled healthcare professionals with trusted
                employers across India.
              </p>

            </div>

            {/* RIGHT IMAGE */}
            <div className="relative hidden md:flex justify-end items-end h-full min-h-[430px]">

              <div className="absolute right-[-80px] bottom-0 w-[620px] h-[390px] bg-teal-100/70 rounded-t-full" />

              <img
                src={healthcareHero}
                alt="Healthcare professionals"
                className="relative z-10 w-full max-w-[560px] h-[390px] object-cover object-top rounded-t-[180px]"
              />

            </div>

          </div>

        </div>

      </section>


      {/* ================= ABOUT HIRECURA ================= */}
      <section className="bg-white py-8 sm:py-14 md:py-16">

        <div className="max-w-7xl mx-auto px-4 sm:px-6">

          <div className="grid lg:grid-cols-2 gap-12 items-center">

            {/* LEFT */}
            <div>

              <p className="text-sm uppercase tracking-[0.18em] text-teal-600 font-semibold mb-3">
                Who We Are
              </p>

              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold leading-tight text-[#10243e]">
                Healthcare hiring,
                <br />
                made simpler.
              </h2>

              <p className="mt-4 sm:mt-5 text-gray-600 leading-6 sm:leading-7">
                Finding the right healthcare professional can be
                challenging, while talented professionals often spend
                significant time searching for suitable opportunities.
              </p>

              <p className="mt-3 sm:mt-4 text-gray-600 leading-6 sm:leading-7">
                HireCura brings both sides together through a focused
                healthcare recruitment platform where candidates can
                discover opportunities and employers can connect with
                relevant talent.
              </p>

              <p className="mt-3 sm:mt-4 text-gray-600 leading-6 sm:leading-7">
                Our goal is to make healthcare recruitment more
                accessible, organized and straightforward for everyone
                involved.
              </p>

            </div>

            {/* RIGHT CARD */}
            <div className="bg-[#f3fbfa] rounded-2xl sm:rounded-3xl p-4 sm:p-8 md:p-10 border border-teal-50">

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-5">

                <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6">
                  <FaUsers className="text-2xl sm:text-3xl text-teal-600 mb-3 sm:mb-4" />
                  <h3 className="font-bold text-[#10243e]">
                    Healthcare Talent
                  </h3>
                  <p className="text-sm text-gray-500 mt-2">
                    Connecting professionals with relevant opportunities.
                  </p>
                </div>

                <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6">
                  <FaHospital className="text-2xl sm:text-3xl text-teal-600 mb-3 sm:mb-4" />
                  <h3 className="font-bold text-[#10243e]">
                    Healthcare Employers
                  </h3>
                  <p className="text-sm text-gray-500 mt-2">
                    Helping organizations find suitable professionals.
                  </p>
                </div>

                <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6">
                  <FaHeartbeat className="text-2xl sm:text-3xl text-teal-600 mb-3 sm:mb-4" />
                  <h3 className="font-bold text-[#10243e]">
                    Healthcare Focus
                  </h3>
                  <p className="text-sm text-gray-500 mt-2">
                    Built specifically around healthcare recruitment.
                  </p>
                </div>

                <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6">
                  <FaShieldAlt className="text-2xl sm:text-3xl text-teal-600 mb-3 sm:mb-4" />
                  <h3 className="font-bold text-[#10243e]">
                    Trusted Platform
                  </h3>
                  <p className="text-sm text-gray-500 mt-2">
                    Designed with a simple and secure experience in mind.
                  </p>
                </div>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* ================= WHAT WE DO ================= */}
      <section className="bg-[#f8fbfb] py-8 sm:py-14 md:py-16">

        <div className="max-w-7xl mx-auto px-4 sm:px-6">

          <div className="text-center max-w-2xl mx-auto px-1">

            <p className="text-sm uppercase tracking-[0.18em] text-teal-600 font-semibold">
              What We Do
            </p>

            <h2 className="mt-2 text-2xl sm:text-3xl md:text-4xl font-bold leading-tight text-[#10243e]">
              One Platform. Two Sides. Better Connections.
            </h2>

            <p className="mt-4 text-gray-600">
              HireCura brings healthcare professionals and employers
              together through a focused recruitment experience.
            </p>

          </div>


          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mt-6 sm:mt-10">

            {/* CANDIDATES */}
            <div className="bg-white rounded-2xl border border-gray-100 p-4 sm:p-7">

              <div className="w-14 h-14 rounded-full bg-[#e5f8f4] flex items-center justify-center mb-5">
                <FaUser className="text-2xl text-teal-600" />
              </div>

              <h3 className="text-xl sm:text-2xl font-bold leading-snug text-[#10243e]">
                For Healthcare Professionals
              </h3>

              <p className="text-gray-600 mt-3 leading-6">
                Discover healthcare opportunities based on your
                profession, skills, experience and preferred location.
              </p>

              <ul className="mt-4 sm:mt-5 space-y-3">

                <li className="flex gap-3 text-gray-600">
                  <FaCheckCircle className="text-teal-600 mt-1 flex-shrink-0" />
                  Search healthcare jobs
                </li>

                <li className="flex gap-3 text-gray-600">
                  <FaCheckCircle className="text-teal-600 mt-1 flex-shrink-0" />
                  Explore opportunities across locations
                </li>

                <li className="flex gap-3 text-gray-600">
                  <FaCheckCircle className="text-teal-600 mt-1 flex-shrink-0" />
                  Apply and connect with employers
                </li>

              </ul>

              <button
                onClick={() => navigate("/find-jobs")}
                className="mt-5 sm:mt-6 text-teal-600 font-semibold flex items-center gap-2 hover:text-teal-700"
              >
                Explore Jobs
                <FaArrowRight className="text-sm" />
              </button>

            </div>


            {/* EMPLOYERS */}
            <div className="bg-white rounded-2xl border border-gray-100 p-4 sm:p-7">

              <div className="w-14 h-14 rounded-full bg-[#e5f8f4] flex items-center justify-center mb-5">
                <FaBriefcaseMedical className="text-2xl text-teal-600" />
              </div>

              <h3 className="text-xl sm:text-2xl font-bold leading-snug text-[#10243e]">
                For Healthcare Employers
              </h3>

              <p className="text-gray-600 mt-3 leading-6">
                Reach healthcare professionals and simplify the process
                of finding candidates for your organization's requirements.
              </p>

              <ul className="mt-4 sm:mt-5 space-y-3">

                <li className="flex gap-3 text-gray-600">
                  <FaCheckCircle className="text-teal-600 mt-1 flex-shrink-0" />
                  Post healthcare job opportunities
                </li>

                <li className="flex gap-3 text-gray-600">
                  <FaCheckCircle className="text-teal-600 mt-1 flex-shrink-0" />
                  Reach relevant healthcare talent
                </li>

                <li className="flex gap-3 text-gray-600">
                  <FaCheckCircle className="text-teal-600 mt-1 flex-shrink-0" />
                  Review and connect with applicants
                </li>

              </ul>

              <button
                onClick={() => navigate("/for-employers")}
                className="mt-5 sm:mt-6 text-teal-600 font-semibold flex items-center gap-2 hover:text-teal-700"
              >
                For Employers
                <FaArrowRight className="text-sm" />
              </button>

            </div>

          </div>

        </div>

      </section>


      {/* ================= WHY HIRECURA ================= */}
      <section className="bg-white py-8 sm:py-14 md:py-16">

        <div className="max-w-7xl mx-auto px-4 sm:px-6">

          <div className="text-center max-w-2xl mx-auto px-1">

            <p className="text-sm uppercase tracking-[0.18em] text-teal-600 font-semibold">
              Why HireCura
            </p>

            <h2 className="mt-2 text-2xl sm:text-3xl md:text-4xl font-bold leading-tight text-[#10243e]">
              Built Around Healthcare
            </h2>

          </div>


          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6 mt-6 sm:mt-10">

            <div className="text-center p-4 sm:p-6 rounded-2xl bg-[#f8fbfb]">
              <FaHeartbeat className="text-4xl text-teal-600 mx-auto" />

              <h3 className="mt-4 font-bold text-[#10243e]">
                Healthcare Focused
              </h3>

              <p className="text-sm text-gray-500 mt-2">
                A platform centered around healthcare opportunities.
              </p>
            </div>


            <div className="text-center p-4 sm:p-6 rounded-2xl bg-[#f8fbfb]">
              <FaSearch className="text-4xl text-teal-600 mx-auto" />

              <h3 className="mt-4 font-bold text-[#10243e]">
                Simple Discovery
              </h3>

              <p className="text-sm text-gray-500 mt-2">
                Find relevant opportunities with focused search.
              </p>
            </div>


            <div className="text-center p-4 sm:p-6 rounded-2xl bg-[#f8fbfb]">
              <FaUsers className="text-4xl text-teal-600 mx-auto" />

              <h3 className="mt-4 font-bold text-[#10243e]">
                Talent Connection
              </h3>

              <p className="text-sm text-gray-500 mt-2">
                Bringing professionals and employers together.
              </p>
            </div>


            <div className="text-center p-4 sm:p-6 rounded-2xl bg-[#f8fbfb]">
              <FaShieldAlt className="text-4xl text-teal-600 mx-auto" />

              <h3 className="mt-4 font-bold text-[#10243e]">
                Trusted Experience
              </h3>

              <p className="text-sm text-gray-500 mt-2">
                Designed for a straightforward recruitment journey.
              </p>
            </div>

          </div>

        </div>

      </section>


      {/* ================= CTA ================= */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 pb-8">

        <div className="bg-gradient-to-r from-[#e8faf7] to-[#f2fbfa] rounded-2xl px-4 sm:px-8 py-5 sm:py-8 flex flex-col md:flex-row items-stretch md:items-center justify-between gap-4 sm:gap-6">

          <div>

            <h2 className="text-2xl md:text-3xl font-bold text-[#10243e]">
              Ready to Explore HireCura?
            </h2>

            <p className="text-gray-600 mt-2">
              Find healthcare opportunities or connect with healthcare talent.
            </p>

          </div>

          <div className="flex flex-col sm:flex-row w-full md:w-auto gap-3">

            <button
              onClick={() => navigate("/find-jobs")}
              className="w-full sm:w-auto justify-center bg-teal-600 hover:bg-teal-700 text-white px-5 sm:px-7 py-3 rounded-xl font-semibold flex items-center gap-2 transition"
            >
              Find Jobs
              <FaArrowRight className="text-sm" />
            </button>

            <button
              onClick={() => navigate("/for-employers")}
              className="w-full sm:w-auto justify-center border border-teal-600 text-teal-700 hover:bg-teal-50 px-5 sm:px-7 py-3 rounded-xl font-semibold flex items-center gap-2 transition"
            >
              Hire Talent
              <FaArrowRight className="text-sm" />
            </button>

          </div>

        </div>

      </section>


      {/* ================= FOOTER ================= */}
      <Footer />
    <LoginModal
  isOpen={showLoginModal}
  initialRole={loginRole}
  onClose={() => setShowLoginModal(false)}
/>
    </div>
  );
}

export default AboutUs;